import PolicyLayout from "@/components/PolicyLayout";

export default function PrivacyPolicyPage() {
  return (
    <PolicyLayout title="Privacy Policy">
      <p>
        Pickle Wall LLC ("Pickle Wall," "we," "us," or "our") respects your privacy.
        This page explains, in general terms, how we handle information you share
        with us through itspicklewall.com — for example when you place an order,
        join our mailing list, or contact us.
      </p>
      <p>
        We collect information you provide directly (like your name, email, phone,
        and shipping address) and information generated when you use the site
        (like pages visited). Payment details are processed securely by our
        payment provider, Stripe — we do not store your full card number.
      </p>
      <p>
        We use this information to fulfill orders, respond to inquiries, send
        updates you've opted into, and improve the site. We do not sell your
        personal information.
      </p>
      <p>
        Our full, detailed privacy policy is currently being finalized with legal
        counsel and will be published here. In the meantime, if you have questions
        about your data or want it deleted, contact us directly using the email
        below and we'll respond promptly.
      </p>
    </PolicyLayout>
  );
}
